import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Input,
  Link,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Email from "../signIn/email.tsx";
import { useForgotPass } from "../../../hooks/useForgotPass.ts";
// import { DevTool } from "@hookform/devtools";

const ForgetPassword = ({ setForgot }: { setForgot: (x: boolean) => void }) => {
  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: {
      login: "",
    },
  });
  const { submit, forgot, loading } = useForgotPass(methods.reset);
  const onSubmit = (data: { login: string }) => {
    submit(data.login);
  };
  return (
    <FormProvider {...methods}>
      <VStack
        justifyContent="center"
        p="40px"
        spacing="20px"
        bg="#f7f8fc"
        borderRadius="10px"
        boxShadow="lg"
        maxW="500px"
        mx="auto"
      >
        <HStack justifyContent="space-between" w="100%">
          <Heading color="#111833" size="lg">
            {t("Sign In")}
          </Heading>
        </HStack>
        <Box w="100%" display="flex" flexDirection="column" gap="30px">
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            {forgot ? (
              <VStack>
                <Controller
                  name="login"
                  control={methods.control}
                  render={({ field }) => (
                    <Input placeholder="please enter otp" {...field} />
                  )}
                />
                <Button
                  mt="20px"
                  isLoading={loading}
                  w="100%"
                  _hover={{ bg: "#090632" }}
                  type="submit"
                  bg="#111833"
                  color="white"
                  fontSize="18px"
                  fontWeight="600"
                >
                  {t("send")}
                </Button>
              </VStack>
            ) : (
              <VStack gap="20px">
                <Email />
                <Flex width="100%" justifyContent="flex-end">
                  <Link
                    onClick={() => setForgot(false)}
                    color="#7848f4"
                    fontWeight="600"
                    fontSize="sm"
                    _hover={{ textDecoration: "underline" }}
                  >
                    {t("Sign in")}
                  </Link>
                </Flex>
                <Button
                  mt="20px"
                  isLoading={loading}
                  w="100%"
                  _hover={{ bg: "#090632" }}
                  type="submit"
                  bg="#111833"
                  color="white"
                  fontSize="18px"
                  fontWeight="600"
                >
                  {t("Forget Password")}
                </Button>
              </VStack>
            )}
          </form>
        </Box>
      </VStack>
    </FormProvider>
  );
};

export default ForgetPassword;
